var _circle, _text, _circle2, _text2, _circle3, _text3, _path, _path2, _path3, _circle4, _circle5, _circle6, _circle7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFrameworks(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 260",
    fill: "none",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 100,
    r: 20,
    stroke: "#38bdf8",
    strokeWidth: 1.5
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 105,
    textAnchor: "middle",
    fill: "#38bdf8",
    fontSize: 16,
    fontFamily: "sans-serif"
  }, "?")), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 100,
    r: 20,
    stroke: "#fafcfb",
    strokeWidth: 1.5
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 200,
    y: 105,
    textAnchor: "middle",
    fill: "#fafcfb",
    fontSize: 16,
    fontFamily: "sans-serif"
  }, "?")), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 280,
    cy: 100,
    r: 20,
    stroke: "#fbbf24",
    strokeWidth: 1.5
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 280,
    y: 105,
    textAnchor: "middle",
    fill: "#fbbf24",
    fontSize: 16,
    fontFamily: "sans-serif"
  }, "?")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M140 100 L180 100",
    stroke: "#38bdf8",
    strokeWidth: 1,
    strokeOpacity: 0.5,
    markerEnd: "url(#arrow)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M220 100 L260 100",
    stroke: "#fafcfb",
    strokeWidth: 1,
    strokeOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M168 195 Q168 118 200 105 Q232 118 232 195 Q200 208 168 195 Z",
    stroke: "#fafcfb",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 186,
    cy: 148,
    r: 4,
    fill: "#fafcfb"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 214,
    cy: 148,
    r: 4,
    fill: "#fafcfb"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 170,
    r: 2,
    fill: "#fbbf24"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 310,
    cy: 165,
    r: 1.5,
    fill: "#38bdf8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrameworks);
export default __webpack_public_path__ + "static/media/frameworks.6a2d9644818702eab85a866b36c44bee.svg";
export { ForwardRef as ReactComponent };